import { FormFieldTypes } from "../../../../data/formFieldType";

const SearchFilterFormData = {
    name: "Search Filter Form",
    initialState: {
        ProjectTypeId: null,
    },
    formFields: [
        {
            id: "ProjectTypeId",
            lable: "Project",
            Field_Name: "ProjectTypeId",
            fieldType: FormFieldTypes.SELECT,
            dataField: "ProjectTypeId",
            fieldSetting: {
                placeholder: "",
                options: []
            },
            style: {
                containerCss: "col-lg-5 mb-4"
            }
        },
    ]
}
export default SearchFilterFormData;
